import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=aca5ed58&scoped=true"
import script from "./wxlogin.vue?vue&type=script&lang=js"
export * from "./wxlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5ed58",
  null
  
)

export default component.exports